import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { T } from '@flipster/i18n';
import type { PswapOrder } from '@flipster/r230522/model/prex.v2.r230522.tables.private_orders';
import { Button } from '@flipster/react/design-system/button';
import PlusIcon from '@flipster/react/icon/generated/PlusIcon';
import { css } from '@flipster/styled-system/css';
import { hstack, stack } from '@flipster/styled-system/patterns';

import { MovableModal } from '../../shared/movable-modal';
import { tpslModalBunja } from '../state';
import { PositionInfo } from './position-info';
import { tpslManageModalBunja } from './state';
import { TpslOrderItem } from './tpsl-order-item';

interface Props {
  onClickModify: (tpslOrder: PswapOrder) => void;
  onClickAdd: () => void;
}

export const TpslManageContent = ({ onClickModify, onClickAdd }: Props) => {
  const { tpslOrdersAtom } = useBunja(tpslManageModalBunja);
  const { tpslType } = useBunja(tpslModalBunja);
  const tpslOrders = useAtomValue(tpslOrdersAtom);

  return (
    <MovableModal.Content>
      <div className={stack({ gap: 24 })}>
        <PositionInfo />
        <div className={stack({ gap: 10 })}>
          <div className={hstack({ justify: 'space-between' })}>
            <p className={css({ textStyle: 'Title/S' })}>
              {tpslType === 'tp' ? (
                <T id='Trade.r260423.Partial_take_profit' />
              ) : (
                <T id='Trade.r260423.Partial_stop_loss' />
              )}
            </p>
            <Button
              hierarchy='primary'
              size='small'
              color='neutral'
              label={<T id='Common.r250401.Add' />}
              icon={<PlusIcon />}
              onClick={onClickAdd}
            />
          </div>
          <ul className={stack({ gap: 10 })}>
            {tpslOrders.map((tpslOrder) => (
              <li key={tpslOrder.orderId}>
                <TpslOrderItem order={tpslOrder} onClickModify={onClickModify} />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </MovableModal.Content>
  );
};
